import { Navigate, Outlet } from "react-router";
import { useAuth } from "./AuthProvider";
import { USER_ROLES } from "./userRoles";

const ClinicalCoderGuard = () => {
  const { role, loading } = useAuth();

  // Wait for role to be fetched before making decision
  if (loading) {
    return null;
  }

  if (role !== USER_ROLES.admin && role !== USER_ROLES.clinical_coder_admin && role !== USER_ROLES.clinical_coder) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default ClinicalCoderGuard;
